import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFieldError = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M4.42577 8.96791C6.85774 4.65597 8.07373 2.5 9.99935 2.5C11.925 2.5 13.141 4.65597 15.5729 8.96791L15.876 9.50522C17.8969 13.0884 18.9074 14.88 17.9941 16.19C17.0809 17.5 14.8214 17.5 10.3024 17.5H9.6963C5.17732 17.5 2.91783 17.5 2.00456 16.19C1.0913 14.88 2.10178 13.0884 4.12273 9.50523L4.42577 8.96791Z",
			stroke: "#DB5543",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10 6.66699V10.8337",
			stroke: "#DB5543",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 9.99935,
			cy: 13.3333,
			r: .5,
			fill: "#DB5543",
			stroke: "#DB5543",
			strokeWidth: .666667
		})
	]
});
const ForwardRef = forwardRef(SvgFieldError);
export { ForwardRef as ReactComponent };
